import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import { FiArrowUpRight, FiLayers } from 'react-icons/fi';

export default function Mainmenu() {
  return <>
    <a className="skip-link" href="#main-content">Aller au contenu</a>
    <div className="brand-bar"><div className="home-container">Des compétences pour avancer. <span>Une entreprise du groupe <strong>MuvoGroup</strong></span></div></div>
    <Navbar expand="lg" className="site-navigation" collapseOnSelect>
      <Container className="home-container">
        <Navbar.Brand as={Link} to="/" className="site-brand"><span className="brand-symbol"><FiLayers aria-hidden="true" /></span><span>auto<span className="brand-light">formations</span><small>APPRENDRE POUR AVANCER</small></span></Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navigation" aria-label="Ouvrir le menu" />
        <Navbar.Collapse id="main-navigation">
          <Nav className="ms-auto align-items-lg-center">
            <Nav.Link as={NavLink} to="/" end eventKey="home">Accueil</Nav.Link>
            <Nav.Link as={NavLink} to="/formations" eventKey="formations">Nos formations</Nav.Link>
            <Nav.Link as={NavLink} to="/a-propos" eventKey="about">À propos</Nav.Link>
            <Nav.Link as={NavLink} to="/contact" eventKey="contact">Contact</Nav.Link>
            <Nav.Link as={Link} to="/contact" eventKey="project" className="nav-project">Parlons de votre projet <FiArrowUpRight aria-hidden="true" /></Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  </>;
}
